export default __webpack_public_path__ + "static/media/bv.83241487.svg";